import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';

import TextField from '~/components/TextField';
import TextFieldWithTooltip from '~/components/TextFieldWithTooltip';

import styles from './Configure.style';
import Embed from './Embed';

class Configure extends React.Component {
  constructor(props) {
    super(props);

    let form = props.form;
    form.action_label = form.action_label || 'Submit';
    form.success_message = form.success_message || 'Thank you!';

    this.state = {
      form: form,
    };
  }

  updateForm() {
    const { form } = this.state;
    this.props.onChange(form, true);
  }

  changeAndUpdateForm(attrs) {
    this.setState(
      {
        form: {
          ...this.state.form,
          ...attrs,
        },
      },
      this.updateForm,
    );
  }

  onUpdate(attr, value) {
    const { form } = this.props;

    // No changes
    if (form[attr] === value) return;

    let attrs = {};
    attrs[attr] = value;

    this.changeAndUpdateForm(attrs);
  }

  onTextChange(attr, event) {
    const { value } = event.target;
    return this.onUpdate(attr, value);
  }

  onSelectChange(attr, event) {
    return this.onUpdate(attr, event.target.value);
  }

  onToggle(attr, event) {
    return this.onUpdate(attr, event.target.checked);
  }

  render() {
    const { classes } = this.props;
    const { form } = this.state;

    const formFields = [
      {
        label: 'Form title',
        name: 'title',
        tooltip: 'The title to show above the form (if any).',
        type: 'text',
        placeholder: null,
      },
      {
        label: 'Submit Button Text',
        name: 'action_label',
        tooltip: "Set the form's submit button text.",
        type: 'text',
        placeholder: 'Submit',
      },
      {
        label: 'Submission URL',
        name: 'action_url',
        tooltip:
          'Redirect your users to this URL on successful form submission',
        type: 'url',
        placeholder: 'https://example.com',
      },
      {
        label: 'Success message',
        name: 'success_message',
        tooltip: 'Message shown on successful form submission',
        type: 'text',
        placeholder: 'Thank you!',
      },
      {
        label: 'Fallback form URL',
        name: 'fallback_url',
        tooltip:
          'A link to an alternative form which will be displayed in the rare case our form fails to load.',
        type: 'url',
        placeholder: 'https://example.com',
      },
    ];

    return (
      <div className={classes.root}>
        <div className={classes.pane}>
          <Grid container spacing={40}>
            <Grid item xs>
              <TextField
                autoFocus={false}
                variant="standard"
                fullWidth
                InputProps={{
                  classes: { root: classes.input, input: classes.largeInput },
                }}
                value={form.name}
                onChange={this.onTextChange.bind(this, 'name')}
                key="name"
              />

              {formFields.map((formField) => (
                <TextFieldWithTooltip
                  fullWidth
                  multiline={false}
                  labelValue={formField.label}
                  name={formField.name}
                  onChange={this.onTextChange.bind(this, formField.name)}
                  tooltipPlacement="right"
                  tooltipTitle={formField.tooltip}
                  value={form[formField.name] || ''}
                  wrapperClassName={classes.input}
                  placeholder={formField.placeholder}
                  key={formField.name}
                />
              ))}

              <TextFieldWithTooltip
                fullWidth
                select
                labelValue="Theme"
                name="theme"
                onChange={this.onSelectChange.bind(this, 'theme')}
                tooltipPlacement="right"
                tooltipTitle="Set to `None` if you are providing your own CSS styling for the form."
                value={form.theme || 'default'}
                wrapperClassName={classes.input}>
                <MenuItem value={'default'}>Default</MenuItem>

                <MenuItem value={'none'}>None</MenuItem>
              </TextFieldWithTooltip>

              <Embed form={form} />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

Configure.propTypes = {
  classes: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(Configure);
